import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { DonViTinh } from '@/types/schemas';

export const getDataTableColumns = (handleViewClick: (row: DonViTinh) => void): DataTableColumn<DonViTinh>[] => [
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 150,
    renderCell: (params: DataTableRenderCellParams<DonViTinh>) => (
      <button onClick={() => handleViewClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {String(params.value ?? '')}
      </button>
    )
  },
  { field: 'ten_dvt', headerName: 'Diễn giải', width: 200 }
];
